import request from '@/apis/request'
const resource = 'transactions' 

export default {
  get: (params = {}) => {
    return request.get(`${resource}`, { params })
  }, 
}